import React from "react";
import type { TagType, VariantType } from "@shared/graphql.types";
import { useScreenViewport } from "lib/checkViewport";
import { Box, Text } from "@chakra-ui/react";
import { colours } from "@shared/ui.design-system";
import { space } from "theme/themeConfig";
import { Tags } from "components/ProductCard/Tags";
type ProductCardTextProps = {
  variant: VariantType;
  tags: TagType[];
};
export const ProductCardText: React.FC<ProductCardTextProps> = ({
  variant,
  tags
}) => {
  const { isTiny } = useScreenViewport();
  const { brandName, title, subTitle, availability } = variant;
  const outOfStock = availability?.status === "outofstock";
  const isComingSoon = availability?.label?.toLowerCase() === "coming soon";
  const showOutOfStock = outOfStock && !isComingSoon;

  return (
    <Box opacity={showOutOfStock ? "50%" : ""}>
      {brandName?.length > 0 && (
        <Text
          mb={space["-6"]}
          variant="acuminMedium"
          fontSize={isTiny ? -1 : 1}
          mt="0"
          lineHeight={1}
          color={colours.primary.dark}
        >
          {brandName}
        </Text>
      )}
      <Text
        variant="acuminLight"
        fontSize={isTiny ? -1 : 1}
        mt={0}
        color={colours.primary.dark}
        lineHeight={1}
        dangerouslySetInnerHTML={{
          __html: title ?? ""
        }}
      />
      <Text
        variant="acuminLight"
        fontSize={isTiny ? -1 : 1}
        color={colours.primary.medium}
        mt={-6}
        lineHeight={1}
        dangerouslySetInnerHTML={{
          __html: subTitle ?? ""
        }}
      />
      <Tags tags={tags} />
    </Box>
  );
};
